import { isAdmin, useSession } from "../session.tsx";
import { useResidencyReport } from "./ResidencyScreen.tsx";

/**
 * Whether to offer the backoffice. The session's roles cover its current entity only, while the
 * server lets an admin of any of the user's entities in: when the roles say no, the residency
 * report (403 to non-admins) decides. Presentation only; every backoffice route checks itself.
 */
export function useBackofficeAccess(): "yes" | "no" | "unknown" {
  const { roles } = useSession();
  const byRole = isAdmin(roles);
  const report = useResidencyReport(!byRole);
  if (byRole || report.isSuccess) {
    return "yes";
  }
  return report.isError ? "no" : "unknown";
}
